import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "reactstrap"

export default function Discount() {
  const[searchParams, setSearchParams] = useSearchParams();
  const [isDiscount, setIsDiscount ] = useState(searchParams.get('is_discount') || '');

  const handleIsDiscount = (discount) => {
    setIsDiscount(discount);
    searchParams.set('is_discount', discount);
    searchParams.delete('page');
    setSearchParams(searchParams);
  }

  useEffect(() => {
    setIsDiscount(searchParams.get('is_discount') || '');
  }, [searchParams])
 
  return (
    <>
        Discount:
            <Button 
                onClick={(e) => handleIsDiscount(e.target.value)}
                value={'0'}
                outline
                size="sm"
                className={`${'0' == isDiscount ? 'active' : ''} d-inline-block ms-2 p-1`}
                >
                All
            </Button>
            <Button 
                onClick={(e) => handleIsDiscount(e.target.value)}
                value={'1'}
                outline
                size="sm"
                className={`${'1' == isDiscount ? 'active' : ''} d-inline-block ms-2 p-1`}
                >
                Discount
            </Button>
    </>
  )
}
